import React, { useState } from "react";
import FindModal from "./FindModal";
import ReplaceModal from "./ReplaceModal";

export default function FindReplaceModal({ open, onClose, fields }) {
  const [searchResults, setSearchResults] = useState(null);
  const [searchField, setSearchField] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showFindModal, setShowFindModal] = useState(true);
  const [showReplaceModal, setShowReplaceModal] = useState(false);

  const handleFindClose = () => {
    setShowFindModal(false);
    if (!showReplaceModal) {
      onClose();
    }
  };

  const handleReplaceClose = () => {
    setShowReplaceModal(false);
    setSearchResults(null);
    setSearchField("");
    setSearchText("");
    onClose();
  };

  const handleFindComplete = (results, field, text) => {
    setSearchResults(results);
    setSearchField(field);
    setSearchText(text);
    setShowFindModal(false);
    setShowReplaceModal(true);
  };

  if (!open && (showFindModal || showReplaceModal)) {
    setShowFindModal(false);
    setShowReplaceModal(false);
    setSearchResults(null);
    setSearchField("");
    setSearchText("");
  }

  return (
    <>
      <FindModal 
        open={open && showFindModal} 
        onClose={handleFindClose} 
        fields={fields}
        onFindComplete={handleFindComplete}
      />
      <ReplaceModal 
        open={showReplaceModal} 
        onClose={handleReplaceClose} 
        searchResults={searchResults}
        field={searchField}
        findText={searchText}
      />
    </>
  );
}
